import { underscore } from '@ember/string';
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  keyForAttribute(attr) {
    return underscore(attr);
  },
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);
    return {
      audience: json
    };
  },
  normalize(modelClass, resourceHash) {
    return this._super(modelClass, {
      ...resourceHash,
      type: modelClass.modelName
    });
  },
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // There's a all_audiences_count_of_email and all_audiences_count_of_sms in the
    //  payload that we're not using here.  See getMarketingAudiences if you want those.
    const newPayload = payload.audience || payload.audiences;
    return this._super(store, primaryModelClass, newPayload, id, requestType);
  },
  pushPayload(store, payload) {
    const modelClass = store.modelFor('marketing/marketing-audience');
    const normalized = this.normalizeSingleResponse(store, modelClass, payload);

    // pushPayload does not return the record.
    // If the record is needed after this function, use peekRecord.
    store.push(normalized);
  }
});